const currentHost = window.location.hostname;
const local = {
  apiUrl: "https://eqplus-admin.dev.mypepsico.com/v2/dopservice",
  apiUrlWeb: "https://eqplus-admin.dev.mypepsico.com/webservices",
  ssoClientId: "0oa1nwzgmlrojvIdW0h8",
  ssoIssuer: "https://secure.ite.pepsico.com/oauth2/default",
};

const dev = {
  apiUrl: "https://eqplus-admin.dev.mypepsico.com/v2/dopservice",
  apiUrlWeb: "https://eqplus-admin.dev.mypepsico.com/webservices",
  ssoClientId: "0oa1nwzgmlrojvIdW0h8",
  ssoIssuer: "https://secure.ite.pepsico.com/oauth2/default",
};

const staging = {
  apiUrl: "https://eqplus-admin.qa.mypepsico.com/v2/dopservice",
  apiUrlWeb: "https://eqplus-admin.qa.mypepsico.com/webservices",
  ssoClientId: "0oa1nwzgmlrojvIdW0h8",
  ssoIssuer: "https://secure.ite.pepsico.com/oauth2/default",
};

const production = {
  apiUrl: `https://admin.${currentHost}/v2/dopservice`,
  apiUrlWeb: `https://admin.${currentHost}/webservices`,
  ssoClientId: "0oa1sydgqfrvdNhQ20h8",
  ssoIssuer: "https://secure.pepsico.com/oauth2/aus1ljxpv3z9G8NGl0h8",
};

const gae = {
  apiUrl: "https://eqplus-admin.gae.qa.mypepsico.com/v2/dopservice",
  apiUrlWeb: "https://eqplus-admin.gae.qa.mypepsico.com/webservices",
  ssoClientId: "0oa1nwzgmlrojvIdW0h8",
  ssoIssuer: "https://secure.ite.pepsico.com/oauth2/default",
};

let env;
if (currentHost === "localhost") {
  env = gae;
} else if (currentHost === "eqplus.dev.mypepsico.com") {
  env = dev;
} else if (currentHost === "eqplus.qa.mypepsico.com") {
  env = staging;
} else if (currentHost === "mcoe.mypepsico.com") {
  env = production;
} else if (currentHost === "eqplus.gae.qa.mypepsico.com") {
  env = gae;
}


export default env;
